import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";

export default function AddDevices() {
  const navigate = useNavigate();

  const [devices, setDevices] = useState([
    { deviceName: "", deviceId: "", deviceInfo: "" },
  ]);

  const [dosingUnits, setDosingUnits] = useState([]);
  const [showDosing, setShowDosing] = useState(false);

  const addUserData = JSON.parse(localStorage.getItem("addUserData") || "{}");

  /* ---------- Device handlers ---------- */
  const addDevice = () => {
    setDevices([...devices, { deviceName: "", deviceId: "", deviceInfo: "" }]);
  };

  /* ---------- Dosing handlers ---------- */
  const addDosingUnit = () => {
    setShowDosing(true);
    setDosingUnits([
      ...dosingUnits,
      {
        deviceId: "",
        deviceName: "Dosing Unit",
        solutionCapacity: "",
        dripAmount: "",
        deviceInfo: "",
        deviceType: "DOSING",
      },
    ]);
  };




const handleDone = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem("addUserData"));

    if (!userData) {
      alert("User data missing");
      return;
    }

    const { confirmPassword, ...cleanUserData } = userData;

    // ✅ NORMAL DEVICES
    const normalDevices = devices.map((d) => ({
      deviceId: d.deviceId.trim(),
      deviceName: d.deviceName.trim(),
      deviceInfo: d.deviceInfo?.trim() || null,
    }));

    // ✅ DOSING UNITS
    const dosingPayload = dosingUnits.map((d) => ({
      deviceId: d.deviceId.trim(),
      solutionCapacity: Number(d.solutionCapacity),
      dripAmount: Number(d.dripAmount),
      deviceInfo: d.deviceInfo?.trim() || null,
    }));

    // VALIDATION
    if (normalDevices.some((d) => !d.deviceId || !d.deviceName)) {
      alert("Device Name and Device ID are required");
      return;
    }

    if (normalDevices.length === 0 && dosingPayload.length === 0) {
      alert("Please add at least one device");
      return;
    }

    const payload = {
      ...cleanUserData,
      role: "USER",
      enabled: true,
      status: "ACTIVE",
      phoneNumber: String(cleanUserData.phoneNumber),
      logoUrl: cleanUserData.logoUrl?.startsWith("http")
        ? cleanUserData.logoUrl
        : null,
      template: Number(cleanUserData.template),

      // ✅ CORRECT SEPARATION
      devices: normalDevices,
      dosingUnits: dosingPayload,
    };

    await axios.post(
      "https://api.livestockify.com/api/admin/users",
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    localStorage.removeItem("addUserData");
    navigate("/all-users");
  } catch (err) {
    console.error("CREATE USER FAILED:", err.response?.data || err);
  }
};


  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 bg-white rounded-l-2xl p-6 overflow-y-auto">
        {/* STEP INDICATOR */}
        <div className="flex justify-center mb-8">
          <div className="flex flex-col items-center">
            <div className="flex items-center">
              <div className="w-4 h-4 bg-green-700 rounded-full" />
              <div className="w-40 h-[2px] bg-green-700" />
              <div className="w-4 h-4 bg-green-700 rounded-full" />
            </div>
            <div className="flex justify-between w-[210px] mt-2">
              <span className="text-green-700 font-semibold text-sm">Add User</span>
              <span className="text-green-700 font-semibold text-sm">Add Devices</span>
            </div>
          </div>
        </div>

        {/* SKIP */}
        <div className="flex justify-end mb-6">
          <button
            onClick={() => navigate("/all-users")}
            className="text-sm font-medium"
          >
            Skip &gt;
          </button>
        </div>

        {/* FORM */}
        <div className="max-w-3xl mx-auto space-y-8">
          {/* DEVICES */}
          {devices.map((device, index) => (
            <div key={index} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-2">
                <label className="text-sm font-medium md:text-right pr-8">Device Name</label>

                <input
                  placeholder="Device Name"
                  value={device.deviceName}
                  onChange={(e) => {
                    const updated = [...devices];
                    updated[index].deviceName = e.target.value;
                    setDevices(updated);
                  }}
                  className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-2">
                <label className="text-sm font-medium md:text-right pr-8">Device ID</label>

                <input
                  placeholder="Device ID"
                  value={device.deviceId}
                  onChange={(e) => {
                    const updated = [...devices];
                    updated[index].deviceId = e.target.value;
                    setDevices(updated);
                  }}
                  className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 items-start gap-2">
                <label className="text-sm font-medium md:text-right pr-8">Device Info</label>

                <textarea
                  placeholder="Device Info"
                  value={device.deviceInfo}
                  onChange={(e) => {
                    const updated = [...devices];
                    updated[index].deviceInfo = e.target.value;
                    setDevices(updated);
                  }}
                  className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
                />
              </div>

              {/* ADD ONE MORE BUTTON – ONLY ONCE */}
              <div className="flex justify-end">
                <button
                  onClick={addDevice}
                  className="bg-blue-500 text-white px-4 py-1 rounded-md text-sm"
                >
                  Add One More
                </button>
              </div>
            </div>
          ))}

          {/* ADD DOSING UNIT */}
          <div className="flex justify-center">
            <button
              onClick={addDosingUnit}
              className="w-full border-2 border-dashed border-green-400 bg-green-50 text-black py-3 rounded-lg font-semibold"
            >
              Add Dosing Unit
            </button>
          </div>

          {/* DOSING UNITS */}
          {showDosing &&
            dosingUnits.map((dosingUnit, index) => (
              <div key={index} className="space-y-4 mt-6">
                <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-2">
                  <label className="text-sm font-medium md:text-right pr-8">Device ID</label>
                  <input
                    placeholder="Enter Device ID"
                    value={dosingUnit.deviceId}
                    onChange={(e) => {
                      const updated = [...dosingUnits];
                      updated[index].deviceId = e.target.value;
                      setDosingUnits(updated);
                    }}
                    className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-2">
                  <label className="text-sm font-medium md:text-right pr-8">Solution Capacity</label>
                  <input
                    placeholder="Enter Solution Capacity"
                    value={dosingUnit.solutionCapacity}
                    onChange={(e) => {
                      const updated = [...dosingUnits];
                      updated[index].solutionCapacity = e.target.value;
                      setDosingUnits(updated);
                    }}
                    className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
                    type="number"
                    step="any"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-2">
                  <label className="text-sm font-medium md:text-right pr-8">Drip Amount</label>
                  <input
                    placeholder="Enter Drip Amount"
                    value={dosingUnit.dripAmount}
                    onChange={(e) => {
                      const updated = [...dosingUnits];
                      updated[index].dripAmount = e.target.value;
                      setDosingUnits(updated);
                    }}
                    className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
                    type="number"
                    step="any"
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 items-start gap-2">
                  <label className="text-sm font-medium md:text-right pr-8">Device Info</label>
                  <textarea
                    rows="4"
                    placeholder="Enter Device Info (JSON Format)"
                    value={dosingUnit.deviceInfo}
                    onChange={(e) => {
                      const updated = [...dosingUnits];
                      updated[index].deviceInfo = e.target.value;
                      setDosingUnits(updated);
                    }}
                    className="md:col-span-2 border px-3 py-2 rounded-md text-sm"
                  />
                </div>
              </div>
            ))}

          {/* FOOTER */}
          <div className="flex justify-end gap-4 pt-6">
            <button
              onClick={() => navigate("/add-user")}
              className="border px-6 py-2 rounded-md text-sm"
            >
              Cancel
            </button>
            <button
              onClick={handleDone}
              className="bg-green-500 text-white px-6 py-2 rounded-md text-sm"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
